import { t } from '@/i18n';
import { formatDateTime, formatShortDate } from '@/lib/time';
import type { Quote } from '@/types';

/** A NAV is only meaningful with its publication date, so that label carries it. */
export function freshnessLabel(f: Quote['freshness'], asOf?: number): string {
  if (f === 'nav') return asOf == null ? t('fresh.navUndated') : t('fresh.nav', { date: formatShortDate(asOf) });
  return t(`fresh.${f}` as const);
}

export function sourceLabel(src: Quote['source']): string {
  switch (src) {
    case 'finnhub': return 'Finnhub';
    case 'massive': return 'Massive';
    case 'twelvedata': return 'Twelve Data';
    case 'tmx': return 'TMX Money';
    case 'coinbase': return 'Coinbase';
    case 'frankfurter': return t('source.ecb');
    case 'manual': return t('source.manual');
    case 'fixed': return t('fresh.base');
  }
}

export function FreshnessBadge({ quote, withSource = false, fallback }: { quote: Quote | undefined; withSource?: boolean; fallback?: string }) {
  if (!quote) return <span className="badge"><i className="dot off" />{fallback ?? t('fresh.none')}</span>;
  const dot = quote.stale ? 'dot off' : quote.freshness === 'realtime' ? 'dot' : quote.freshness === 'delayed15' ? 'dot delay' : 'dot close';
  const label = freshnessLabel(quote.freshness, quote.asOf);
  const text = quote.stale ? t('fresh.stale', { label }) : label;
  return (
    <span className="badge" title={`${sourceLabel(quote.source)} · ${formatDateTime(quote.asOf)}`}>
      <i className={dot} />
      {withSource ? `${text} · ${sourceLabel(quote.source)}` : text}
    </span>
  );
}

export function FxBadge({ date }: { date: string | undefined }) {
  return <span className="badge"><i className={date ? 'dot close' : 'dot off'} />{date ? t('fresh.fx', { date: date.slice(5) }) : t('fresh.fxNone')}</span>;
}
